import { render, staticRenderFns } from "./RequestStatusesSelectMenu.vue?vue&type=template&id=67176cd6"
import script from "./RequestStatusesSelectMenu.vue?vue&type=script&lang=ts"
export * from "./RequestStatusesSelectMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports